import React from 'react';
import { homeObjFour, homeObjThree, homeObjTwo } from './Data';
import { InfoSection } from '../../components';

const Services = () => {
    return (
        <div>
            <InfoSection {...homeObjTwo} />
            <InfoSection {...homeObjThree} />
            <InfoSection {...homeObjFour} />
        </div>
    )
}

export default Services;
